import { useMutation } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { interpolate } from "@/helpers"
import { toast } from "@/hooks/use-toast"
import i18n from "@/i18n"
import { StringHelper } from "@/utils"
const getURLProvider = async (email: string) => {
  const url = interpolate(ENDPOINTS.LOGIN_WITH_PROVIDER, {
    email,
  })
  const { data } =
    await api.get<SSOUrlProviderResponseType>(url, {
      headers: {
        "x-origin-domain": window.location.hostname,
      },
    })
  return data
}
const useSSOAuth = () => {
  return useMutation({
    mutationFn: (email: string) => getURLProvider(email),
    onSuccess: (data) => {
      if (!StringHelper.isNullOrEmpty(data?.url)) {
        window.location.href = data?.url
      } else {
        toast({
          title: i18n.t("auth.ssoProviderError"),
          variant: "destructive",
        })
      }
    },
    onError: () => {
      toast({
        title: i18n.t("auth.ssoProviderError"),
        variant: "destructive",
      })
    },
  })
}
export default useSSOAuth
